<div class="modal-body bg-light p-0" *transloco="let t">
  <div class="bg-white" [class.mb-3]="!progressState.isFinal">
    <!--- Chọn dữ liệu ------------------------------------------------------------------>
    <div class="p-3 pb-1">
      <div class="row">
        <div class="col-xl-2 col-12 my-0">
          <label class="form-label fw-semibold">
            {{ t('common.selectData') }}:
          </label>
        </div>
        @if (options.excelListPage) {
          <div class="d-flex flex-wrap gap-3 col-xl-10 col-12">
            @for (page of options.excelListPage.list; track page) {
              <div class="me-xl-4 me-0">
                <app-checkbox
                  [options]="{
 componentType: 'form-switch',
 type: 'radio',
 name: 'isListPages',
 color: 'success'
 }"
                  [value]="page.key"
                  [label]="t(page.value)"
                  [checked]="page.key == state.pageSelection"
                  (valueChange)="state.pageSelection = $event"
                />
              </div>
            }
          </div>
        }
      </div>
    </div>
    <!--- End Chọn dữ liệu ------------------------------------------------------------------>

    <!--- Handle tabs ------------------------------------------------------------------>
    <div class="d-lg-flex justify-content-between align-items-center mt-2">
      <app-c-nav-tabs
        [navTabs]="navTabs"
        (tabEvent)="onChangeTab($event)"
      />

      @if (state.tabRef != 'googleSheets' || (state.tabRef == 'googleSheets' && accessTokenOptions.length)) {
        <div
          [class.justify-content-between]="state.tabRef == 'googleSheets'"
          [class.justify-content-end]="state.tabRef == 'excel'"
          class="d-lg-flex flex-1 justify-content-between px-3 mt-3 mt-lg-0 pb-3 pb-lg-0">
          @if (state.tabRef == 'googleSheets') {
            <div
              class="accessTokenOptions input-group d-flex mb-3 mb-lg-0">
              <!-- Tài khoản kết nối -->
              <app-d-select
                class="flex-1"
                [iconRight]="{
 icon: 'ph ph-trash text-danger',
 }"
                [classInput]="'radius-right-0'"
                [label]="'order.connectedAccount'"
                [data]="accessTokenOptions"
                [values]="[state.accessTokenId ? state.accessTokenId : null]"
                (changeSelect)="onSelectedToken($event)"
                (confirmClickIcon$)="onRevokeTokenGGS($event)"
              />
              <div class="input-group-text text-success cursor-pointer"
                   [title]="t('common.add.connectedAccount')"
                   (click)="onGenerateAuthURL()">
                <i class="ph ph-plus"></i>
              </div>
            </div>
          }
          <!-- Cài đặt đã lưu -->
          @if (settingOptions.length) {
            <app-d-select
              [iconRight]="{
 icon: 'ph ph-trash text-danger',
 }"
              [data]="settingOptions"
              [label]="'common.savedSettings'"
              [values]="[state.settingId ? state.settingId : '']"
              (changeSelect)="onChangeSettingId($event)"
              (confirmClickIcon$)="onRemoveSetting($event)"
            />
          }
        </div>
      }
    </div>
  </div>

  @if (!progressState.isExportSubmit) {
    <!----------------------------------------------------------------------------------------->
      <!----- Start Google Sheets ---------------------------------------------------------------->
      <!----------------------------------------------------------------------------------------->
    @if (state.tabRef == 'googleSheets') {
      @if (isLoadingTabGGSheet) {
        @if (accessTokenOptions.length && !tokenError) {
          <div class="row w-100 p-3 pt-0">
            <!---- Bảng tính ----->
            <div class="col-xl-6 col-12" data-title="Bảng tính">
              <h6 class="fw-semibold mb-3">{{ t('excel.worksheet') }}</h6>
              <div class="d-flex align-items-center mb-3" [class.disableds]="!state.accessTokenId">
                <!-- Tạo file mới -->
                <app-checkbox
                  [classBox]="'me-2'"
                  [value]="TYPE_USE.NEW"
                  [checked]="state.typeUseFile === TYPE_USE.NEW"
                  [options]="{type: 'radio', name: 'typeUseFile'}"
                  (valueChange)="onChangeTypeUseFile($event)"
                />
                <!-- Tạo file mới & điền tên file -->
                <app-floating-invalid class="flex-1" [errorOriginal]="errors['fileNew.fileName']"
                                      data-title="Tạo bảng tính mới">
                  <input type="text"
                         class="form-control"
                         placeholder="Nhanh.vn_Order"
                         [disabled]="state.typeUseFile !== TYPE_USE.NEW"
                         [class.border-danger]="!!errors['fileNew.fileName']"
                         [class.pe-4]="!!errors['fileNew.fileName']"
                         (ngModelChange)="onChangeValue('fileNew.fileName', $event)"
                         [(ngModel)]="state.fileNew.fileName">
                  <label>{{ t('googleSheets.create.newSpreadsheet') }}</label>
                </app-floating-invalid>
              </div>
              <div class="d-flex align-items-center" [class.disableds]="!state.accessTokenId">
                <!-- Dùng file Google Sheets có sẵn -->
                <app-checkbox
                  [classBox]="'me-2'"
                  [value]="TYPE_USE.AVAILABLE"
                  [checked]="state.typeUseFile === TYPE_USE.AVAILABLE"
                  [options]="{type: 'radio', name: 'typeUseFile'}"
                  (valueChange)="onChangeTypeUseFile($event)"
                />
                <div class="flex-1" data-title="Điền link file có sẵn">
                  <app-floating-invalid [errorOriginal]="errors['spreadId']">
                    <input type="text"
                           class="form-control showPlaceholder"
                           placeholder="https://docs.google.com/spreadsheets/..."
                           [disabled]="state.typeUseFile !== TYPE_USE.AVAILABLE"
                           [class.border-danger]="!!errors['spreadId']"
                           [class.pe-4]="!!errors['spreadId']"
                           [(ngModel)]="state.googleFile.spreadUrl"
                           (change)="onChangeSpreadGGUrl(state.googleFile.spreadUrl)"
                    >
                    <label class="focusIn">{{ t('googleSheets.enter.existingFile.link') }}</label>
                  </app-floating-invalid>
                </div>
              </div>
              @if (state.googleFile.spreadUrl && !errors['spreadId']) {
                <a
                  [href]="state.googleFile.spreadUrl"
                  [style.margin-left.rem]="1.7"
                  target="_blank" class="btn btn-light fw-semibold mt-2">
                  {{ t('common.view.file') }}
                </a>
              }
            </div>
            <!---- Trang tính ----->
            <div class="col-xl-6 col-12" data-title="Trang tính">
              <h6 class="fw-semibold mt-2 mt-lg-0 mb-3">{{ t('excel.spreadsheet') }}</h6>
              <div [class.disableds]="!state.accessTokenId">
                <div class="d-flex align-items-center mb-3">
                  <app-checkbox
                    [classBox]="'me-2'"
                    [value]="TYPE_USE.NEW"
                    [checked]="state.googleFile.typeUseSheet === TYPE_USE.NEW"
                    [options]="{type: 'radio', name: 'typeUseSheet'}"
                    (valueChange)="state.googleFile.typeUseSheet = $event"
                  />
                  <app-floating-invalid class="flex-1"
                                        [errorOriginal]="errors['spreadSheetNewTitle']">
                    <input type="text"
                           class="form-control"
                           placeholder="Nhanh.vn_Order_y-m-d_h_i_s"
                           [disabled]="state.googleFile.typeUseSheet === TYPE_USE.AVAILABLE"
                           [class.border-danger]="!!errors['spreadSheetNewTitle']"
                           [class.pe-4]="!!errors['spreadSheetNewTitle']"
                           (ngModelChange)="onChangeValue('spreadSheetNewTitle', $event)"
                           [(ngModel)]="state.googleFile.spreadSheetNewTitle">
                    <label>Tên trang tính mới</label>
                  </app-floating-invalid>
                </div>
                <!-- Chỉ google sheet mới có chọn trang tính đã có -->
                @if (state.typeUseFile === TYPE_USE.AVAILABLE) {
                  <div class="d-flex align-items-center">
                    <app-checkbox
                      [classBox]="'me-2'"
                      [value]="TYPE_USE.AVAILABLE"
                      [checked]="state.googleFile.typeUseSheet === TYPE_USE.AVAILABLE"
                      [options]="{type: 'radio', name: 'typeUseSheet'}"
                      (valueChange)="state.googleFile.typeUseSheet = $event"
                    />
                    <!-- Trang tính đã có sẵn -->
                    <app-d-select
                      class="w-100 flex-1"
                      [fieldInvalid]="!!errors['spreadSheetId']"
                      [disabled]="state.googleFile.typeUseSheet === TYPE_USE.NEW ||
 !state.googleFile.spreadUrl || !sheetOptions.length"
                      [label]="'export.data.spreadsheet.alreadyExists'"
                      [data]="sheetOptions"
                      [values]="[state.googleFile.spreadSheetId ? state.googleFile.spreadSheetId : '']"
                      (changeSelect)="onChangeGoogleSheetId($event)"
                    />
                  </div>
                }
              </div>
            </div>
          </div>
        } @else {
          <div class="w-100 p-3 pt-0 text-center" data-title="Yêu cầu kết nối tài khoản">
            @if (!tokenError) {
              <div class="alert alert-warning fw-semibold">
                {{ t('export.data.noAccessToken') }}
              </div>
            } @else {
              <div class="alert alert-danger fw-semibold">
                {{ t('googleSheets.noAccessToken') }}
              </div>
            }
            <button type="button" class="btn btn-primary fw-semibold"
                    [disabled]="appForm.disabledSubmit"
                    (click)="onGenerateAuthURL()">
              <i class="ph ph-google-logo"></i>
              <span class="ms-2">{{ t('common.loginWithGoogle') }}</span>
            </button>
            @if (tokenError) {
              <div class="text-center mt-3">
                <app-img-custom className="img-fluid"
                                [src]="'/assets/img/sample/Google_Sheets_Allow_Permission.jpg' | imgCdn" alt=""/>
              </div>
            }
          </div>
          <div class="d-flex justify-content-end bg-white w-100 p-3">
            <button type="button" class="btn btn-light btn-sm fw-semibold" (click)="activeModal.dismiss()">
              {{ t('common.close') }}
            </button>
          </div>
        }
        <!----- Yêu cầu cấp & xác nhận token ---------------------------------------------------------------->
      } @else {
        <div class="p-3 pt-0 text-center">
          <app-spin-loader/>
          <h6>{{ 'common.loading.data.pleaseWait' | transloco }}</h6>
        </div>
      }
    }
    <!--------------------------------------------------------------------------------------->
      <!----- End Google Sheet ---------------------------------------------------------------->
      <!--------------------------------------------------------------------------------------->
      <!----------------------------------------------------------------------------------------->
      <!----- Start tab Excel ---------------------------------------------------------------->
      <!----------------------------------------------------------------------------------------->
    @if (state.tabRef == 'excel') {
      <!---- Tên File ----->
      <div class="row w-100 p-3 pt-0">
        <div class="col-xl-6 col-12" data-title="Bảng tính">
          <h6 class="fw-semibold mb-2">{{ t('excel.worksheet') }}</h6>
          <app-floating-invalid class="flex-1" [errorOriginal]="errors['fileNew.fileName']">
            <input type="text"
                   class="form-control"
                   placeholder="Nhanh.vn_Order"
                   [(ngModel)]="state.fileNew.fileName">
          </app-floating-invalid>
        </div>
        <div class="col-xl-6 col-12" data-title="Trang tính">
          <h6 class="fw-semibold mt-3 mt-lg-0 mb-2">{{ t('excel.spreadsheet') }}</h6>
          <div class="d-flex align-items-center mb-2">
            <app-floating-invalid class="flex-1" [errorOriginal]="errors['fileNew.sheetName']">
              <input type="text"
                     class="form-control"
                     placeholder="Nhanh.vn_Order_y-m-d_h_i_s"
                     [class.border-danger]="!!errors['fileNew.sheetName']"
                     [class.pe-4]="!!errors['fileNew.sheetName']"
                     (ngModelChange)="onChangeFileSheetName($event)"
                     [(ngModel)]="state.fileNew.sheetName">
            </app-floating-invalid>
          </div>
        </div>
      </div>
    }
    <!--------------------------------------------------------------------------------------->
      <!----- End tab Excel ---------------------------------------------------------------->
      <!--------------------------------------------------------------------------------------->
  }

  <!-- Tab excel hoặc google sheet thì phải chọn token rồi -->
  @if (state.tabRef != 'googleSheets' || accessTokenOptions.length) {
    <!--- Cài đặt ẩn hiện cột ------------------------------------------------------------------------>
    @if (!progressState.isExportSubmit && state.columns.length) {
      <div
        [class.disableds]="(state.tabRef == 'googleSheets' && !state.accessTokenId)"
        class="w-100 p-3 pt-0">
        <div class="row mb-3">
          <div class="col-12 col-lg-6 d-flex align-items-center" data-title="Chọn cột">
            @if (appForm.appService.screenWidth > SCREEN_GRID_MEDIUM) {
              <div
                [ngbTooltip]="'common.moveOrderExportData' | transloco"
                [style.opacity]="1"
                class="col-item__flag">
                <i class="drag-icon ph ph-arrows-out-cardinal"></i>
              </div>
            }
            <app-checkbox
              [value]="1"
              [checked]="isCheckAll"
              [options]="{type: 'checkbox', componentType: 'form-check'}"
              (valueChange)="onCheckAll()"
            />
            <label for="refSearch"
                   [style.max-width.rem]="22"
                   class="form-control-feedback w-100 ms-2">
              <input type="search" class="form-control ps-2"
                     id="refSearch"
                     autocomplete="off"
                     [formControl]="controlKeypress"
                     [placeholder]="t('common.messages.searchColumnNames')">
              <div class="form-control-feedback-icon column-icon-search h-100">
                <i class="ph ph-magnifying-glass text-muted"></i>
              </div>
            </label>
            <h6 class="fw-semibold d-block d-lg-none mb-0 ms-3">
              <span>{{ t('common.renameColumn') }}</span>
              <i class="ph ph-question text-info ms-2"
                 [ngbTooltip]="t('googleSheets.empty.insertHeadersOrAppendData')"></i>
            </h6>
          </div>
          <div class="col-12 col-lg-6 d-none d-lg-flex" data-title="Đổi tên cột">
            <h6 class="fw-semibold mb-0">
              <span>{{ t('common.renameColumn') }}</span>
              <i class="ph ph-question text-info ms-2"
                 [ngbTooltip]="t('googleSheets.empty.insertHeadersOrAppendData')"></i>
            </h6>
          </div>
        </div>
        <div class="scrollbar-columns pe-2">
          <div class="row">
            <div class="col-12">
              @if (!isResultSearch && controlKeypress.value) {
                <div
                  class="alert alert-warning border-0 alert-dismissible fade show">
                  <span class="fw-semibold">{{ t('common.noMatchingResultsFound') }}</span>
                  <button type="button" aria-label="Close" class="btn-close" (click)="resetSearch()"></button>
                </div>
              }
            </div>
            <div class="col-12 col-lg-6" data-title="Chọn cột">
              <div class="list-cols"
              >
                @for (col of state.columns; track col; let idx = $index) {
                  @if (!col['filterHide']) {
                    <div class="mb-2 d-lg-flex align-items-center"
                         [style.min-height.rem]="2.5">
                      <div class="col-item d-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center">
                          @if (appForm.appService.screenWidth > SCREEN_GRID_MEDIUM) {
                            <div
                              class="col-item__flag">
                              <i class="drag-icon ph ph-arrows-out-cardinal"></i>
                            </div>
                          }
                          <app-checkbox
                            [value]="1"
                            [label]="col.nameOriginal ? col.nameOriginal : t(col.name)"
                            [checked]="!!(col.display || col.required)"
                            [options]="{type: 'checkbox', componentType: 'form-check'}"
                            (valueChange)="colChange($event, col)"
                          />
                        </div>
                        <i class="d-lg-none ph ph-pencil cursor-pointer me-2"
                           (click)="col['isEditMobile'] == 1 ? col['isEditMobile'] = 0 : col['isEditMobile'] = 1"
                           [class.text-primary]="col['isEditMobile']"></i>
                      </div>
                      @if (col['isEditMobile']) {
                        <div class="d-lg-none mt-1 ps-4">
                          <input type="text"
                                 class="form-control"
                                 [(ngModel)]="col.nameExcelCustom"
                                 placeholder="">
                        </div>
                      }
                    </div>
                  }
                }
              </div>
            </div>
            <div class="col-12 col-lg-6 d-none d-lg-flex" data-title="Đổi tên cột">
              <div class="list-cols flex-1">
                @for (col of state.columns; track col; let idx = $index) {
                  @if (!col['filterHide']) {
                    <div class="col-item d-flex align-items-center mb-2">
                      <div class="col-item__apha fw-semibold">
                        {{ idx | columnIndexExcel }}
                      </div>
                      <input type="text"
                             class="form-control"
                             [(ngModel)]="col.nameExcelCustom"
                             placeholder="">
                    </div>
                  }
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    <!--- End Cài đặt ẩn hiện cột ------------------------------------------------------------------>
    @if (!progressState.isFinal && !progressState.isExportSubmit) {
      @if (options.rowDataLoopLabel) {
        <div class="w-100 p-3 pb-0">
          <app-checkbox
            [value]="true"
            [checked]="!!state.rowDataLoop"
            [label]="options.rowDataLoopLabel | transloco"
            (valueChange)="state.rowDataLoop = $event"
          />
        </div>
      }
      <!--- Lưu cài đặt cho lần sau ------------------------------------------------------------------>
      <div [class.pt-0]="!state.columns.length" class="w-100 p-3">
        <!--- Lưu cài đặt cho lần sau ------------------------------------------------------------------>
        @if (options.typeSettingExportData) {
          <div class="form-group mb-2">
            <app-checkbox
              [disabled]="(state.tabRef == 'googleSheets' && !state.accessTokenId)"
              [value]="1"
              [label]="t('export.data.saveSettingAsTemp')"
              [checked]="!!settingState.useSetting"
              (valueChange)="onHandleSetting($event)"
            />
          </div>
        }
        @if (settingState.useSetting) {
          <div class="mt-3">
            <div
              class="d-flex flex-wrap flex-lg-nowrap align-items-center justify-content-end justify-content-lg-start">
              <div class="w-100 mb-2 mb-lg-0 me-lg-3">
                <app-d-select
                  [width]="'400'"
                  [data]="settingScopeTypes"
                  [values]="[settingState.typeScope ? settingState.typeScope : '']"
                  (changeSelect)="onChangeScopeSetting($event)"
                />
              </div>
              <div class="w-100 mb-2 mb-lg-0 me-lg-3">
                <app-d-select
                  [data]="settingSaveTypes"
                  [values]="[settingState.settingTypeSave ? settingState.settingTypeSave : '']"
                  (changeSelect)="onChangeTypeSetting($event)"
                />
              </div>
              <div class="w-100 mb-2 mb-lg-0 me-lg-3">
                <!-- Cài đặt đã lưu -->
                @if (settingState.settingTypeSave == TYPE_USE.AVAILABLE) {
                  <app-d-select
                    [data]="settingState.settingSaveds"
                    [label]="t('common.savedSettings')"
                    [values]="[settingState.settingId ? settingState.settingId : '']"
                    (changeSelect)="settingState.settingId = $event"
                  />
                } @else {
                  <app-floating-invalid [errorOriginal]="errors['settingName']">
                    <input type="text"
                           class="form-control"
                           [placeholder]="t('inventory.transfer.distributeSettingName')"
                           [class.border-danger]="!!errors['settingName']"
                           [class.pe-4]="!!errors['settingName']"
                           [(ngModel)]="settingState.settingNewName">
                    <label>Tên cài đặt</label>
                  </app-floating-invalid>
                }
              </div>
              <button type="button" class="btn btn-success btn-sm fw-semibold"
                      [style.max-height.rem]="2.25"
                      (click)="onSaveSetting()"
                      [disabled]="settingState.isSubmit">
                <i class="ph ph-floppy-disk-back me-2"></i>
                {{ t('common.save') }}
              </button>
            </div>
          </div>
        }
      </div>
      <!--- End Lưu cài đặt cho lần sau ------------------------------------------------------------------>
    }
    <div class="bg-white w-100 p-3">
      @if (progressState.isFinal && state.tabRef == 'googleSheets') {
        <div class="alert alert-success fw-semibold">
          <!-- Xuất file Google Sheets thành công -->
          <div class="mb-2">
            <i class="ph ph-check text-success me-2"></i>
            <span>{{ t('export.data.googleSheets.success') }}</span>
          </div>
          <a [href]="progressState.spreadData?.spreadUrl" class="btn btn-primary btn-sm" target="_blank">
            <i class="ph ph-arrow-square-out me-2"></i>
            {{ t('common.open.file') }} Google Sheets
          </a>
        </div>
      }
      <div class="d-lg-flex align-items-center justify-content-between">
        <!--- Process ------------------------------------------------------------------>
        @if (progressState.isExportSubmit && !progressState.isFinal) {
          <div
            class="d-flex flex-auto flex-lg-2 mb-3 mb-lg-0 me-lg-4">
            <p class="mb-0 me-3">
              <i class="ph ph-caret-up me-3"></i>
              {{ t('common.exportingData') }}:
              <span class="currentItem">{{ progressState.currentItem }}</span>
              @if (progressState.totalPages > 0) {
                / <span class="totalItems">{{ progressState.totalItems }}</span>
              }
            </p>
            <div class="flex-1">
              <app-progress-bar
                [totalPages]="progressState.totalPages"
                [currentPage]="progressState.currentPage"/>
            </div>
          </div>
        }
        <!--- End Process ------------------------------------------------------------------>
        <div class="d-flex flex-auto flex-lg-1 justify-content-end">
          @if (!progressState.isFinal) {
            <button type="button" class="btn btn-primary btn-sm text-nowrap fw-semibold"
                    [disabled]="progressState.isExportSubmit || (state.tabRef == 'googleSheets' && !state.accessTokenId)"
                    (click)="onExportData()">
              {{ t('common.exportData') }}
            </button>
          }
          <button type="button" class="btn btn-light btn-sm text-nowrap ms-3 fw-semibold"
                  (click)="activeModal.dismiss()">
            {{ t('common.close') }}
          </button>
        </div>
      </div>
    </div>
  }
</div>
